import type { Company as CompanyType } from '@/types/company'

import { BODY_FONT, splitLines, wrapText } from '../text.utils'
import type { TicketElement } from '../TicketElement'

export class Company implements TicketElement {
  company: CompanyType
  lineHeight: number
  nameMargin: number
  topMargin: number

  constructor(company: CompanyType) {
    this.company = company
    this.lineHeight = 20
    this.nameMargin = 10
    this.topMargin = 20
  }

  height(ctx: CanvasRenderingContext2D, width: number): number {
    if (!this.company.name || !this.company.taxId) return 0
    ctx.font = `16px ${BODY_FONT}`
    const singleLines = 2
    const lines = singleLines + splitLines(ctx, this.company.address, width).length
    return this.lineHeight * lines + this.nameMargin + this.topMargin
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number): void {
    if (!this.company.name || !this.company.taxId) return
    top += this.topMargin
    ctx.font = `bold 16px ${BODY_FONT}`
    ctx.fillStyle = 'black'
    ctx.textAlign = 'center'
    ctx.fillText(this.company.name, width / 2, top)
    top += this.lineHeight + this.nameMargin
    ctx.font = `16px ${BODY_FONT}`
    ctx.fillText(this.company.taxId, width / 2, top)
    top += this.lineHeight
    wrapText(ctx, this.company.address, width / 2, top, width, {
      lineHeight: this.lineHeight
    })
  }
}
